module.exports = new __parcel__URL__("shadowbomb.267a767b.png").toString();